import { FC } from "react";
import { LayoutProps } from "styled-system";

import CardWithNoImage from "./CardWithNoImage";
import WideCardWithNoImage from "./WideCardWithNoImage";
import CardWithIcon from "./CardWithIcon";
import HalfImageCard from "./HalfImageCard";
import FullImageCard from "./FullImageCard";
import { FeaturedCardContent, FeaturedCardVariant } from "./FeaturedCard";

const CardDecider: FC<{
  variant: FeaturedCardVariant;
  content: FeaturedCardContent;
  width?: LayoutProps["width"];
  height?: LayoutProps["height"];
}> = ({ variant, content, width, height }) => {
  switch (variant) {
    case "NoImageCard":
      return (
        <CardWithNoImage
          headline={content.headline || ""}
          description={content.description || ""}
          moreInfo={content.moreInfo}
          width={width}
          height={height}
        ></CardWithNoImage>
      );
    case "NoImageWideCard":
      return (
        <WideCardWithNoImage
          headline={content.headline || ""}
          description={content.description || ""}
          width={width}
          height={height}
        ></WideCardWithNoImage>
      );
    case "IconCard":
      return (
        <CardWithIcon
          headline={content.headline || ""}
          description={content.description || ""}
          icon={content.icon}
          width={width}
          height={height}
        ></CardWithIcon>
      );
    case "IconWideCard":
      return (
        <CardWithIcon
          headline={content.headline || ""}
          description={content.description || ""}
          icon={content.icon}
          width={width}
          height={height}
          isWide
        ></CardWithIcon>
      );
    case "HalfImageCard":
      return (
        <HalfImageCard
          headline={content.headline || ""}
          description={content.description || ""}
          image={content.image}
          moreInfo={content.moreInfo}
          width={width}
          height={height}
        ></HalfImageCard>
      );
    case "HalfImageWideCard":
      return (
        <HalfImageCard
          headline={content.headline || ""}
          description={content.description || ""}
          image={content.image}
          moreInfo={content.moreInfo}
          isWideCard={true}
          width={width}
        ></HalfImageCard>
      );
    case "FullImageCard":
      return (
        <FullImageCard
          headline={content.headline || ""}
          image={content.image}
          moreInfo={content.moreInfo}
          width={width}
        ></FullImageCard>
      );
    case "FullImageSmallCard":
      return (
        <FullImageCard
          headline={content.headline || ""}
          image={content.image}
          moreInfo={content.moreInfo}
          isSmallCard={true}
          width={width}
        ></FullImageCard>
      );
    default:
      return null;
  }
};

export default CardDecider;
